import React, { useState } from "react";
import { Share2, Check, Link2 } from "lucide-react";

const nativeShareSupported = typeof navigator !== "undefined" && typeof navigator.share === "function";

// One-tap share: opens the phone's native share sheet where available,
// and gracefully falls back to copying the link (e.g. on most desktops).
export const ShareButton = ({ url, title, text, label = "Share", className, testid = "share-button", hideIfUnsupported = false }) => {
  const [copied, setCopied] = useState(false);
  const supported = nativeShareSupported;
  if (!supported && hideIfUnsupported) return null;

  const copy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.top = "-9999px";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Copy this link:", url);
    }
  };

  const onClick = async () => {
    if (supported) {
      try {
        await navigator.share({ title, text, url });
      } catch {
        // user dismissed the sheet or share failed, no action needed
      }
    } else {
      copy();
    }
  };

  const base = "inline-flex items-center gap-2 border border-white/15 text-zinc-200 hover:bg-white/5 font-body text-sm px-4 py-2.5 transition-colors";

  return (
    <button onClick={onClick} data-testid={testid} className={className || base}>
      {supported ? (
        <><Share2 size={15} /> {label}</>
      ) : copied ? (
        <><Check size={15} className="text-[#14A89A]" /> Link copied</>
      ) : (
        <><Link2 size={15} /> Copy link</>
      )}
    </button>
  );
};
